import * as firebase from 'firebase';
import * as firebase_auth from '../constants/firebase';

const prodConfig = {
  apiKey: firebase_auth.PROD_API_KEY,
  authDomain: firebase_auth.PROD_AUTH_DOMAIN,
  databaseURL: firebase_auth.PROD_DATABASE_URL,
  projectId: firebase_auth.PROD_PROJECT_ID,
  storageBucket: firebase_auth.PROD_STORAGE_BUCKET,
  messagingSenderId: firebase_auth.PROD_MESSAGING_SENDER_ID,
};

const devConfig = {
  apiKey: firebase_auth.DEV_API_KEY,
  authDomain: firebase_auth.DEV_AUTH_DOMAIN,
  databaseURL: firebase_auth.DEV_DATABASE_URL,
  projectId: firebase_auth.DEV_PROJECT_ID,
  storageBucket: firebase_auth.DEV_STORAGE_BUCKET,
  messagingSenderId: firebase_auth.DEV_MESSAGING_SENDER_ID,
};

const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();

export {
  db,
  auth,
  firebase
};


// WEBPACK FOOTER //
// ./src/firebase/firebase.js